(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header')
			this.headerWrapper = document.querySelector('.header-wrapper')
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always'
			this.headerBounds = {}
			this.currentScrollTop = 0
			this.preventReveal = false
			this.predictiveSearch = this.querySelector('predictive-search')

			this.onScrollHandler = this.onScroll.bind(this)
			this.hideHeaderOnScrollUp = () => (this.preventReveal = true)

			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.addEventListener('scroll', this.onScrollHandler, false)

			this.createObserver()
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
			window.removeEventListener('scroll', this.onScrollHandler)
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect
				observer.disconnect()
			})

			if (this.header) {
				observer.observe(this.header)
			}
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop

			if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
				this.header.classList.add(
					'shopify-section-header-sticky',
					'shopify-section-header-always-sticky',
				)
				this.header.classList.remove('color-background-3')
				this.header.style.transition =
					'background var(--duration-short), transform var(--duration-default)'
			}

			if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
				this.header.classList.remove('shopify-section-header-sticky')
				this.header.style.transition = 'background var(--duration-short)'
				if (this.header.classList.contains('color-background-1')) {
					this.header.classList.add('color-background-3')
				}
			}

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (this.preventHide) return
				requestAnimationFrame(this.hide.bind(this))
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
				if (!this.preventReveal) {
					requestAnimationFrame(this.reveal.bind(this))
				} else {
					window.clearTimeout(this.isScrolling)

					this.isScrolling = setTimeout(() => {
						this.preventReveal = false
					}, 66)

					requestAnimationFrame(this.hide.bind(this))
				}
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this))
			}

			this.currentScrollTop = scrollTop
		}

		hide() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
			this.closeMenuDisclosure()
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.add('shopify-section-header-sticky', 'animate')
			this.header.classList.remove('shopify-section-header-hidden', 'color-background-3')
		}

		reset() {
			if (this.headerIsAlwaysSticky) return
			this.header.classList.remove(
				'shopify-section-header-hidden',
				'shopify-section-header-sticky',
				'animate',
			)
			if (this.header.classList.contains('color-background-1')) {
				this.header.classList.add('color-background-3')
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure')
			if (this.disclosures) {
				this.disclosures.forEach((disclosure) => {
					disclosure.close()
				})
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list')
			if (this.disclosureLists) {
				this.disclosureLists.forEach((disclosureList) => {
					disclosureList.setAttribute('hidden', true)
				})
			}
		}
	}

	customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    const activeMedia = this.querySelector(
      `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
    );

    if (
      activeMedia.nodeName == 'DEFERRED-MEDIA' &&
      activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
    ) {
      activeMedia.loadContent();
    }
  }
}

customElements.define('product-modal', ProductModal);

/* ========= 大图放大：PC 悬停放大 / 手机点击放大并可拖动 ========= */
(function () {
  // ★ 放大倍数：PC 和手机分开配置
  const DESKTOP_ZOOM_SCALE = 2.5;
  const MOBILE_ZOOM_SCALE = 2.5; // ← 手机端放大倍数在这里改

  function setupZoomForImage(img) {
    if (!(img instanceof HTMLImageElement)) return;

    // 已经包过就跳过
    if (img.closest('.js-image-zoom-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'js-image-zoom-wrapper';
    wrapper.style.position = 'relative';
    wrapper.style.overflow = 'hidden';

    const parent = img.parentNode;
    parent.insertBefore(wrapper, img);
    wrapper.appendChild(img);

    img.style.willChange = 'transform';
    img.style.transition = 'transform 0.15s ease-out';
    img.style.transformOrigin = 'center center';

    const isDesktop =
      window.matchMedia &&
      window.matchMedia('(pointer: fine)').matches &&
      window.innerWidth >= 990;

    const isTouch =
      'ontouchstart' in window || navigator.maxTouchPoints > 0;

    /* ====== 桌面端：鼠标移入放大 + 跟随鼠标移动 ====== */
    if (isDesktop) {
      const zoomScale = DESKTOP_ZOOM_SCALE;

      wrapper.addEventListener('mouseenter', function () {
        wrapper.classList.add('is-zoomed');
      });

      wrapper.addEventListener('mouseleave', function () {
        wrapper.classList.remove('is-zoomed');
        img.style.transform = 'translate(0px, 0px) scale(1)';
      });

      wrapper.addEventListener('mousemove', function (event) {
        if (!wrapper.classList.contains('is-zoomed')) return;

        const rect = wrapper.getBoundingClientRect();
        const relX = (event.clientX - rect.left) / rect.width;  // 0 ~ 1
        const relY = (event.clientY - rect.top) / rect.height; // 0 ~ 1

        // 让鼠标所在点尽量靠近容器中心
        const moveX = (0.5 - relX) * (zoomScale - 1) * rect.width;
        const moveY = (0.5 - relY) * (zoomScale - 1) * rect.height;

        img.style.transform =
          'translate(' + moveX + 'px,' + moveY + 'px) scale(' + zoomScale + ')';
      });

      return;
    }

    /* ====== 手机 / 触屏端：点击放大 + 手指拖动查看细节 ====== */
    if (isTouch) {
      const zoomScale = MOBILE_ZOOM_SCALE;

      let zoomed = false;
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let currentY = 0;
      let startTX = 0;
      let startTY = 0;

      function applyTransform() {
        img.style.transform =
          'translate(' + currentX + 'px,' + currentY + 'px) scale(' + zoomScale + ')';
      }

      function resetTransform() {
        currentX = 0;
        currentY = 0;
        img.style.transform = 'translate(0px, 0px) scale(1)';
      }

      // 点击切换放大 / 还原
      wrapper.addEventListener('click', function () {
        zoomed = !zoomed;
        if (zoomed) {
          wrapper.classList.add('is-zoomed');
          currentX = 0;
          currentY = 0;
          applyTransform();

          // ★ 手机端：放大时把当前大图滚到屏幕中间
          try {
            wrapper.scrollIntoView({
              block: 'center',
              inline: 'nearest',
              behavior: 'smooth'
            });
          } catch (e) {
            // 老旧浏览器不支持 options，就退化为默认行为
            wrapper.scrollIntoView();
          }
        } else {
          wrapper.classList.remove('is-zoomed');
          resetTransform();
        }
      });

      // 记录拖动开始位置
      wrapper.addEventListener(
        'touchstart',
        function (e) {
          if (!zoomed) return;
          if (e.touches.length !== 1) return;

          const t = e.touches[0];
          startX = t.clientX;
          startY = t.clientY;
          startTX = currentX;
          startTY = currentY;
        },
        { passive: true }
      );

      // 拖动时移动图片
      wrapper.addEventListener(
        'touchmove',
        function (e) {
          if (!zoomed) return;
          if (e.touches.length !== 1) return;

          const t = e.touches[0];
          const dx = t.clientX - startX;
          const dy = t.clientY - startY;

          const rect = wrapper.getBoundingClientRect();

          // 简单边界限制：最多移动放大多出的那一半
          const maxX = (zoomScale - 1) * rect.width / 2;
          const minX = -maxX;
          const maxY = (zoomScale - 1) * rect.height / 2;
          const minY = -maxY;

          currentX = Math.max(minX, Math.min(maxX, startTX + dx));
          currentY = Math.max(minY, Math.min(maxY, startTY + dy));

          applyTransform();
          e.preventDefault();
        },
        { passive: false }
      );
    }
  }

  function initZoom(scope) {
    const root = scope || document;
    const images = root.querySelectorAll('.js-image-zoom');
    images.forEach(setupZoomForImage);
  }

  function runInitZoom(root) {
  // 桌面端：直接執行，確保一載入就有懸停放大
  const isDesktop =
    window.matchMedia &&
    window.matchMedia('(pointer: fine)').matches &&
    window.innerWidth >= 990;

  if (isDesktop) {
    initZoom(root);
    return;
  }

  // 手機 / 觸控端：延後到空閒或稍後再執行，避免阻塞初次載入
  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () {
      initZoom(root);
    });
  } else {
    // 部分瀏覽器沒有 requestIdleCallback，就延後一點時間
    setTimeout(function () {
      initZoom(root);
    }, 200);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  runInitZoom(document);
});

document.addEventListener('shopify:section:load', function (event) {
  runInitZoom(event.target);
});

})();

  } catch(e) { console.error(e); }
})();
})();
